module.exports = __webpack_public_path__ + "img/Discord-Wordmark-Black.07714cff.svg";